var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('top-bar'),_c('div',{staticClass:"title"},[_vm._v("Make teamwork more productive")]),_c('div',{staticClass:"d-flex is-justify-content-center"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }